const code_block = {
	marks: "",
	code: true,
	defining: true,
	group: "block",
	content: "text*",
	attrs: { language: { default: null } },
};

export default code_block;
